import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { IProductItem } from '@core/models/interfaces/product/product-item.interface';
import { ProductStateService } from '@core/services/product/product-state.service';
import { ProductService } from '@core/services/product/product.service';
import { TpAboutSilvioSantosHoldingComponent } from '@shared/components/tp-about-silvio-santos-holding/tp-about-silvio-santos-holding.component';
import { TpLegalTermsTextComponent } from '@shared/components/tp-legal-terms-text/tp-legal-terms-text.component';
import { TpToastrService } from '@shared/services/tp-toastr.service';

@Component({
  selector: 'app-footer-content',
  standalone: true,
  imports: [
    CommonModule,
    TpAboutSilvioSantosHoldingComponent,
    TpLegalTermsTextComponent,
  ],
  templateUrl: './footer-content.component.html',
  styleUrl: './footer-content.component.scss',
})
export class FooterContentComponent {
  currentProduct!: IProductItem;

  constructor(
    private productService: ProductService,
    private productStateService: ProductStateService,
    private tpToastrService: TpToastrService
  ) {
    this.getCurrentProduct();
  }

  getCurrentProduct() {
    this.productService.getCurrentProduct().subscribe({
      next: (response: IProductItem) => {
        this.currentProduct = response;
        this.updateProduct(this.currentProduct);
      },
      error: () => {
        this.tpToastrService.error(
          'estamos com problemas não foi possível prosseguir'
        );
      },
    });
  }

  updateProduct(product: IProductItem) {
    this.productStateService.updateProduct({ ...product });
  }
}
